import { makeStyles, mergeClasses, shorthands } from "@fluentui/react-components";

import { StyleConstants } from "Shared/Styles/StyleConstants";
import { themeTokens } from "Core/Theme/M365PulseTheme.types";

export const useMainStyles = makeStyles({
    contentBlock: {
        position: "absolute",
        height: `calc(100vh - ${StyleConstants.headerHeight}px - ${StyleConstants.contentBlockPadding}px*2)`,
        overflowX: "hidden",
        overflowY: "auto",
        backgroundColor: themeTokens.colorNeutralBackground1,
        justifyContent: "center",
        display: "block",
        ...shorthands.padding(`${StyleConstants.contentBlockPadding}px`)
    },
    contentWidth: {
        width: `calc(100vw - ${StyleConstants.leftBarWidth}px - ${StyleConstants.contentBlockPadding}px*2)`
    }
});

const useSmallScreenStyles = makeStyles({
    contentWidth: {
        width: `calc(100vw - ${StyleConstants.contentBlockPadding}px*2)`
    }
});

export const useStyles = (isSmallScreen: boolean) => {
    const styles = useMainStyles();
    const smallScreenStyles = useSmallScreenStyles();

    styles.contentBlock = mergeClasses(styles.contentBlock, isSmallScreen ? smallScreenStyles.contentWidth : styles.contentWidth);
    return styles;
};
